import { useState } from 'react';

import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import { DateValidationError, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DateField } from '@mui/x-date-pickers/DateField';
import { DayPickerProps } from 'react-day-picker';

import Calendar from './Calendar';

import { Button } from '@/shared/components/button';

interface SingleCalendarProps {
  calenderProps?: DayPickerProps;
  required?: boolean;
  date: Date | undefined;
  handleSetDate: (date: Date | undefined) => void;
  handleClose?: () => void;
}

const SingleCalendar = ({
  calenderProps,
  date,
  handleSetDate,
  required = false,
  handleClose = () => {
    /* empty */
  },
}: SingleCalendarProps) => {
  const [draftDate, setDraftDate] = useState<Date | undefined>(date);
  const [dateError, setDateError] = useState<DateValidationError | null>(null);

  return (
    <Stack display='inline-flex'>
      <Box px={2} py={1.25}>
        <Calendar
          {...calenderProps}
          mode='single'
          selected={draftDate}
          onSelect={(date) => {
            setDraftDate(date);
          }}
          numberOfMonths={2}
        />
      </Box>

      <Divider />

      <Stack
        direction='row'
        px={1}
        py={1.25}
        alignItems='center'
        justifyContent='space-between'
        gap={2}
      >
        <Box>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateField
              size='small'
              label='Date'
              value={draftDate}
              onError={(error) => {
                setDateError(error);
              }}
              onChange={(value) => {
                setDraftDate(value ?? undefined);
              }}
              sx={{ width: '140px' }}
            />
          </LocalizationProvider>
        </Box>

        <Stack direction='row' gap={1.5}>
          <Button
            variant='text'
            onClick={() => {
              setDraftDate(undefined);
            }}
          >
            Clear
          </Button>
          <Button
            variant='outlined'
            onClick={() => {
              setDraftDate(date);
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            variant='contained'
            disabled={!!dateError || (required && !draftDate)}
            onClick={() => {
              handleSetDate(draftDate);
              handleClose();
            }}
          >
            Apply
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default SingleCalendar;
